// removed by extract-text-webpack-plugin
module.exports = {"prefix":"qempo_PhoneForm_prefix-3Wnf1Y_","error":"qempo_PhoneForm_error-QjukDU0","input":"qempo_PhoneForm_input-1bHL9E9","inputs":"qempo_PhoneForm_inputs-2HjnZT6","button":"qempo_PhoneForm_button-1IYVyTl"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/preferences/security/components/PhoneForm/PhoneForm.scss
// module id = 1379
// module chunks = 0